import React from 'react';
import { Typography, Props as TypographyProps } from '../Typography';
type Props = TypographyProps;
export const ArticleSectionTitle = ({
  children,
  ...rest
}: Props) => <Typography {...rest} variant="h2" fontFamily="muliBold" lineHeight="38px" style={{
  wordBreak: 'break-word'
}} data-sentry-element="Typography" data-sentry-component="ArticleSectionTitle" data-sentry-source-file="index.tsx">
    {children}
  </Typography>;